
document.addEventListener('DOMContentLoaded', () => {
    video();
})

const video = () => {
    var vids = document.querySelectorAll("video.player");
    function closeVideo(x) {
        x.removeAttribute('controls');
        x.removeAttribute('autoplay');
        x.pause();
    }
    vids.forEach(video => {
        var closeButton = video.parentElement.lastElementChild;
        // click on close button
        closeButton.addEventListener('click', () => {
            closeVideo(video);
        });
        // click outside
        document.addEventListener('click', function (event) {
            var isClickInside = video.contains(event.target);
            if (!isClickInside) {
                closeVideo(video);
            }
        });

        video.addEventListener('click', function () {
            if (video.paused) {
                setTimeout(() => {
                    video.nextElementSibling.classList.add('hidden');
                    video.setAttribute('controls', 'true');
                    video.setAttribute('autoplay', 'true');
                    video.play();
                }, 300);
            }
            if (video.played) {
                video.pause();
            }
        });

    });

}